
import { useAddonContext } from '../../../contexts/AddonContext';

export const useAddonManager = () => {
    return useAddonContext();
};
